import Vue from "vue";
import Vuex from "vuex";
import { getModule } from "vuex-module-decorators";
import { AnnotationsState, UiState } from "./types";

Vue.use(Vuex);

export interface RootState {
  annotations: AnnotationsState;
  ui: UiState;
}

// Dynamically register modules
const store = new Vuex.Store<RootState>({
  // strict: true,
  // modules: {
  //   annotations,
  //   ui
  // }
});

export default store;

export class StoreError extends Error {
  constructor(message = "") {
    super(message);
    this.name = "StoreError";
  }
}
